import type {FormInstance} from './context';
import type {FormApi} from './types';

/** Wraps a form instance in the handle exposed by `useFormApi`/`formApiRef`. */
export const toFormApi = (form: FormInstance): FormApi => ({
  getValue: name => form.getFieldValue(name),
  reset: () => {
    form.reset();
  },
  setTouched: (name, touched) => {
    form.setFieldMeta(name, meta => ({...meta, isTouched: touched}));
  },
  setValue: (name, value) => {
    form.setFieldValue(name, value);
  },
  setValues: values => {
    const names = new Set([
      ...Object.keys(form.state.values),
      ...Object.keys(values),
    ]);
    for (const name of names) {
      form.setFieldValue(name, values[name]);
    }
  },
});
